import script from "./PatientDataGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientDataGrid.vue?vue&type=script&setup=true&lang=js"

import "./PatientDataGrid.vue?vue&type=style&index=0&id=f43f2f6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43f2f6a"]])

export default __exports__